// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2xBoh","paramInput":"JobSimulator_paramInput__1boEm","input":"JobSimulator_input__2EoFQ"};